import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../../../router/Routes';
import ContainerTemplate from '../../../../../widgets/template/Container';
import PanelActividadExtraView from './PanelActividadExtraView';

const PanelActividadExtraModule = () => {
  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  const route = {
    ...ROUTES.panelPlanEvaluacion,
    title: 'Panel de Plan de Evaluación',
  };
  return (
    <ContainerTemplate
      active={ROUTES.panelActividadExtra}
      routes={[route]}
      subtitle={`Actividad extra de ${actividadesExtrasStore.activo.tipo.toLowerCase()}`}
    >
      <PanelActividadExtraView />
    </ContainerTemplate>
  );
};

export default PanelActividadExtraModule;
